var React = require('react');

function IconAvatar (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 6a3.75 3.75 0 100 7.5A3.75 3.75 0 0012 6zm0 6a2.25 2.25 0 110-4.5 2.25 2.25 0 010 4.5z","key":0}),React.createElement("path",{"d":"M12 1.5a10.5 10.5 0 100 21 10.5 10.5 0 000-21zM7.5 19.78v-1.03a2.25 2.25 0 012.25-2.25h4.5a2.25 2.25 0 012.25 2.25v1.03a8.92 8.92 0 01-9 0zM18 18.7A3.75 3.75 0 0014.24 15h-4.5a3.75 3.75 0 00-3.74 3.7 9 9 0 1111.98 0z","key":1})]);
}

IconAvatar.defaultProps = {"fill":"currentColor","aria-hidden":"true","focusable":"false","viewBox":"0 0 24 24"};

module.exports = IconAvatar;

IconAvatar.default = IconAvatar;
